module.exports = __webpack_public_path__ + "static/media/VictoriaM.6199a157.jpeg";